/* 블로그 → 스토어 클릭 계측 (2026-09-10)
   왜: 워드프레스 블로그에서 상품 링크를 눌러도 GA4 이벤트가 0건이었다.
   같은 클릭에 TikTok·Clarity·Klaviyo 는 정상 발사됐다. 이관 후에도 그대로
   재생산돼 있어(실측: 글 1편 상품링크 51개 · 클릭 후 GA4 0건) 여기서 막는다.

   이벤트: select_content (GA4 권장 이벤트)
     content_type : "blog_to_store"
     item_id      : 상품/컬렉션 핸들
     link_url     : 목적지 경로
     link_text    : 눌린 글자 (60자로 자름)
     link_area    : nav | footer | article_body | product_card | other
     source_blog  : 블로그 핸들
     source_article: 글 핸들 (목록/분류 화면이면 빈 문자열)

   dataLayer → GTM으로 한 번만 보낸다. 직접 gtag 호출은 중복 전송을 만들므로 사용하지 않는다. */
(function () {
  'use strict';
  var SEL = 'a[href*="/products/"], a[href*="/collections/"]';

  function handleOf(href) {
    try {
      var p = new URL(href, location.origin).pathname.replace(/\/$/, '');
      var m = p.match(/\/(?:products|collections)\/([^/]+)/);
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }

  function articleHandle() {
    var m = location.pathname.match(/^\/blogs\/[^/]+\/([^/?#]+)/);
    // /tagged/ 는 글이 아니라 분류 화면이다
    return (m && m[1] !== 'tagged') ? m[1] : '';
  }
  function blogHandle() {
    var m = location.pathname.match(/^\/blogs\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* 헤더 메뉴·푸터 링크도 같은 선택자에 걸린다. 그것까지 한 덩어리로 세면
     '글이 상품으로 보낸 클릭'이라는 지표가 흐려진다 — 어디서 눌렸는지 실어
     집계 쪽에서 가를 수 있게 한다. */
  function areaOf(a) {
    if (a.closest('#site-header, .zzbb-header, .zzbb-drawer')) return 'nav';
    if (a.closest('footer, .ps-footer, #footer')) return 'footer';
    if (a.closest('.entry-content')) return 'article_body';
    if (a.closest('.onz-picked, .onz-also-wrap, .onz-also-track')) return 'product_card';
    return 'other';
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest(SEL) : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href) return;

    var payload = {
      content_type: 'blog_to_store',
      link_area: areaOf(a),
      item_id: handleOf(href),
      link_url: href,
      link_text: (a.textContent || '').trim().slice(0, 60),
      source_blog: blogHandle(),
      source_article: articleHandle()
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'select_content' }, payload));
  }, true);
})();
